import {RemoteGetPrescriptionsList} from 'data/usecases/private/my-hospitalization/remote-get-prescriptions-list';
import {GetPrescriptionsList} from 'domain/usecases/private/my-hospitalization/get-prescriptions-list';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {MyHospitalizationEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetPrescriptionsList = (): GetPrescriptionsList =>
	new RemoteGetPrescriptionsList(
		makeBFFApiUrl(MyHospitalizationEndpoints.prescriptionsList),
		makeAuthorizeHttpClientDecorator(),
	);
